import React, { useRef, useState } from 'react';

const MultiMediaUploadSection = ({
  title,
  maxCount = 3,
  accept = 'image/*,video/*',
  files = [],
  setFiles,
  className = '',
}) => {
  const inputRef = useRef();

  const handleFilesChange = async e => {
    const incoming = Array.from(e.target.files);

    // Convert File objects to base64 strings (matching MediaUpload behavior)
    const base64Promises = incoming.map(file => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
      });
    });

    try {
      const base64Files = await Promise.all(base64Promises);
      setFiles(prev => {
        const merged = [...prev, ...base64Files];
        return merged.slice(0, maxCount);
      });
    } catch (error) {
      console.error('Error converting files to base64:', error);
    }

    e.target.value = '';
  };

  const removeFile = idx => {
    setFiles(prev => prev.filter((_, i) => i !== idx));
  };

  return (
    <div className='flex flex-col w-full'>
      <label className="self-start text-base text-gray-900 mb-1">{title}</label>
      <div className={`border border-secondary rounded-lg p-4 flex-1 mr-4 last:mr-0 ${className}`}>
        {/* dashed drop-zone */}
        <div
          className="border border-dashed border-secondary rounded-md h-40 flex flex-col items-center justify-center cursor-pointer"
          onClick={() => inputRef.current.click()}
        >
          <input
            ref={inputRef}
            type="file"
            accept={accept}
            multiple
            className="hidden"
            onChange={handleFilesChange}
          />
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/dd1772d5874b5cdae8c5ddfe78830a7b7d00a521b518ad3a0f1c5f229c7196d5"
            alt="Upload Placeholder"
            className="object-contain self-center w-8 aspect-square"
          />
          <p className="text-sm text-secondary">Upload {title.toLowerCase()}</p>
          <p className="text-base text-secondary">Max {maxCount} images</p>
        </div>

        {/* previews */}
        {files.length > 0 && (
          <div className="mt-4 grid grid-cols-3 gap-2">
            {files.map((file, i) => {
              // file is now a base64 string or URL string
              const url = file;
              const isVideo = typeof file === 'string' && file.startsWith('data:video');
              return (
                <div key={i} className="relative group">
                  {isVideo ? (
                    <video
                      src={url}
                      className="w-full h-24 object-cover rounded-md"
                    />
                  ) : (
                    <img
                      src={url}
                      className="w-full h-24 object-cover rounded-md"
                    />
                  )}
                  <button
                    type="button"
                    onClick={() => removeFile(i)}
                    className="absolute top-1 right-1 bg-black bg-opacity-50 text-white rounded-full size-6 group-hover:opacity-100 transition"
                  >
                    ✕
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiMediaUploadSection;